<template>
	<div id="spye">
		<NavigationBar />
    <div class="uk-section uk-background-muted uk-padding-remove">
			<div class="uk-container uk-container-expand uk-padding-remove">
				<div class="uk-flex uk-flex-center uk-flex-stretch uk-cover-container" uk-grid>
					<div class="uk-width-1-1">
						<img src="../assets/roomi_store/banner_1.jpg" alt="../Asset 2@2x.png" uk-img>
					</div>
				</div>
			</div>
		</div>
    <!-- end banner -->
		<!-- <Breadcrumb :productName="Breadcrumb.productName" /> -->
    <div class="uk-section uk-padding">
      <div class="uk-grid-collapse uk-child-width-expand@s uk-text-center uk-margin-remove-top" uk-grid>
          <div class="left-sample">
              <img src="../assets/roomi_store/banner_2.jpg" alt="../Asset 2@2x.png" width="100%" height="30%" uk-img>
          </div>
          <div class="right-sample">
              <img src="../assets/roomi_store/banner_3.jpg" alt="../Asset 2@2x.png" width="100%" height="30%" uk-img>
          </div>
      </div>
    </div>
		<!-- <MainBannerProduct :productName = "banner.productName" 
			:tagline = "banner.tagline" 
			:features = "banner.features" 
			:directLink = "banner.link" 
			:img = "banner.img"
			:posTop = "banner.posTop"
			:posBottom = "banner.posBottom"
			:imageScale = "banner.imageScale"
			:price="banner.price" /> -->
    <section class="uk-section uk-margin-remove-top" id="section-two">
      <h4 class="uk-text-bold uk-text-center">ROOMI STORE PIK 2</h4>
      <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slider="center: true">
        <div class="uk-slider-items uk-child-width-1-1 uk-grid-small uk-grid center">
          <div class="uk-width-1-2">
            <div class="uk-panel image-container uk-cover">
              <img src="../assets/roomi_store/foto_store/TAMPAK DEPAN.jpg" alt="">
              <div class="uk-position-center uk-panel"><h1></h1></div>
            </div>
          </div>
          <div class="uk-width-1-2">
            <div class="uk-panel  image-container">
              <img src="../assets/roomi_store/foto_store/TAMPAK BELAKANG.jpg" width="600" height="400" alt="">
              <div class="uk-position-center uk-panel"><h1></h1></div>
            </div>
          </div>
          <div class="uk-width-1-2">
            <div class="uk-panel  image-container">
              <img src="../assets/roomi_store/foto_store/area pengunjung.jpg" width="600" height="400" alt="">
              <div class="uk-position-center uk-panel"><h1></h1></div>
            </div>
          </div>
          <div class="uk-width-1-2">
            <div class="uk-panel  image-container">
              <img src="../assets/roomi_store/foto_store/area display tv.jpg" width="600" height="400" alt="">
              <div class="uk-position-center uk-panel"><h1></h1></div>
            </div>
          </div>
          <div class="uk-width-1-2">
            <div class="uk-panel  image-container">
              <img src="../assets/roomi_store/foto_store/area cctv dan ott box.jpg" width="600" height="400" alt="">
              <div class="uk-position-center uk-panel"><h1></h1></div>
            </div>
          </div>
          <div class="uk-width-1-2">
            <div class="uk-panel  image-container">
              <img src="../assets/roomi_store/foto_store/testing spk.jpg" width="600" height="400" alt="">
              <div class="uk-position-center uk-panel"><h1>5</h1></div>
            </div>
          </div>
        </div>
        <a class="uk-position-center-left uk-position-small uk-hidden-hover" href uk-slidenav-previous uk-slider-item="previous"></a>
        <a class="uk-position-center-right uk-position-small uk-hidden-hover" href uk-slidenav-next uk-slider-item="next"></a>
      </div>

      <h4 class="uk-text-bold uk-text-center uk-margin-large-top uk-padding-top">ROOMI STORE BOTANI SQUARE</h4>
      <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slider="center: true">
        <div class="uk-slider-items uk-child-width-1-1 uk-grid-small uk-grid center">
          <div class="uk-width-1-2">
            <div class="uk-panel image-container uk-cover">
              <img src="../assets/botani/depan.jpg" width="600" height="400" alt="">
              <div class="uk-position-center uk-panel"><h1></h1></div>
            </div>
          </div>
          <div class="uk-width-1-2">
              <div class="uk-panel image-container">
                  <img src="../assets/botani/samping kiri.jpg" width="600" height="400" alt="">
                  <div class="uk-position-center uk-panel"><h1></h1></div>
              </div>
          </div>
          <div class="uk-width-1-2">
              <div class="uk-panel image-container">
                  <img src="../assets/botani/display cctv dari samping.jpg" width="600" height="400" alt="">
                  <div class="uk-position-center uk-panel"><h1></h1></div>
              </div>
          </div>
          <div class="uk-width-1-2">
              <div class="uk-panel image-container">
                  <img src="../assets/botani/display cctv.jpg" width="600" height="400" alt="">
                  <div class="uk-position-center uk-panel"><h1></h1></div>
              </div>
          </div>
          <div class="uk-width-1-2">
              <div class="uk-panel image-container">
                  <img src="../assets/botani/display spk 2.jpg" width="600" height="400" alt="">
                  <div class="uk-position-center uk-panel"><h1></h1></div>
              </div>
          </div>
          <div class="uk-width-1-2">
              <div class="uk-panel image-container">
                  <img src="../assets/botani/display spk.jpg" width="600" height="400" alt="">
                  <div class="uk-position-center uk-panel"><h1></h1></div>
              </div>
          </div>
          <div class="uk-width-1-2">
              <div class="uk-panel image-container">
                  <img src="../assets/botani/samping kanan.jpg" width="600" height="400" alt="">
                  <div class="uk-position-center uk-panel"><h1></h1></div>
              </div>
          </div>
            
        </div>

        <a class="uk-position-center-left uk-position-small uk-hidden-hover" href uk-slidenav-previous uk-slider-item="previous"></a>
        <a class="uk-position-center-right uk-position-small uk-hidden-hover" href uk-slidenav-next uk-slider-item="next"></a>
    </div>
    </section>
    

<h4 class="uk-text-bold uk-text-center">ROOMI STORE SENAYAN CITY</h4>
<h4 class="uk-text-bold uk-text-center">ROOMI STORE SUMMARECON MALL SERPONG</h4>
<h4 class="uk-text-bold uk-text-center">ROOMI STORE CENTRAL PARK</h4>
<h4 class="uk-text-bold uk-text-center">ROOMI STORE AEON BSD</h4>
<h4 class="uk-text-bold uk-text-center">ROOMI STORE EMPORIUM PLUIT</h4>
<h4 class="uk-text-bold uk-text-center">ROOMI STORE MALL KELAPA GADING</h4>
<h4 class="uk-text-bold uk-text-center">ROOMI STORE SUMMARECON MALL BEKASI</h4>
<h4 class="uk-text-bold uk-text-center">ROOMI STORE AEON DELTA MAS BEKASI</h4>
<!-- 

      <div class="uk-section uk-background-muted uk-padding">
          <h2 class="uk-text-bold uk-text-center">ROOMI STORE PIK 2</h2>
        <div class="uk-child-width-1-3@m uk-grid-small uk-grid-match" uk-grid>
          <div>
              <div class="uk-card  uk-card-body">
                <a class="" href="#modal-tampak-depan" uk-toggle>
                  <img src="../assets/roomi_store/foto_store/TAMPAK DEPAN.jpg" alt="../Asset 2@2x.png" width="100%" height="100%" uk-img>
                </a>
              </div>
          </div>
          <div>
              <div class="uk-card uk-card-body">
                <a class="" href="#modal-tampak-belakang" uk-toggle>
                  <img src="../assets/roomi_store/foto_store/TAMPAK BELAKANG.jpg" alt="../Asset 2@2x.png" width="100%" height="100%" uk-img>
                </a>
              </div>
          </div>
          <div>
              <div class="uk-card uk-card-body">
                <a class="" href="#modal-tampak-pengunjung" uk-toggle>
                  <img src="../assets/roomi_store/foto_store/area pengunjung.jpg" alt="../Asset 2@2x.png" width="100%" height="100%" uk-img>
                </a>
              </div>
          </div>
          <div>
              <div class="uk-card uk-card-body">
                <a class="" href="#modal-area-tv" uk-toggle>
                  <img src="../assets/roomi_store/foto_store/area display tv.jpg" alt="../Asset 2@2x.png" width="100%" height="100%" uk-img>
                </a>
              </div>
          </div>
          <div>
              <div class="uk-card uk-card-body">
                <a class="" href="#modal-area-cctv" uk-toggle>
                  <img src="../assets/roomi_store/foto_store/area cctv dan ott box.jpg" alt="../Asset 2@2x.png" width="100%" height="100%" uk-img>
                </a>
              </div>
          </div>
          <div>
              <div class="uk-card uk-card-body">
                <a class="" href="#modal-testing" uk-toggle>
                  <img src="../assets/roomi_store/foto_store/testing spk.jpg" alt="../Asset 2@2x.png" width="100%" height="100%" uk-img>
                </a>
              </div>
          </div>
      </div>
      <h2 class="uk-text-bold uk-text-center"><li class="uk-button uk-button-primary uk-text-center" style="border-radius: 10px"><router-link to="/store">MORE STORE</router-link></li></h2>
            
		</div>

  <div id="modal-tampak-depan" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
          <button class="uk-modal-close-default" type="button" uk-close></button>
          <img src="../assets/roomi_store/foto_store/TAMPAK DEPAN.jpg" alt="../Asset 2@2x.png" width="100%" height="100%" uk-img>
      </div>
  </div>
  <div id="modal-tampak-belakang" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
          <button class="uk-modal-close-default" type="button" uk-close></button>
          <img src="../assets/roomi_store/foto_store/TAMPAK BELAKANG.jpg" alt="../Asset 2@2x.png" width="100%" height="100%" uk-img>
      </div>
  </div>
  <div id="modal-tampak-pengunjung" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
          <button class="uk-modal-close-default" type="button" uk-close></button>
          <img src="../assets/roomi_store/foto_store/area pengunjung.jpg" alt="../Asset 2@2x.png" width="100%" height="100%" uk-img>
      </div>
  </div>
  <div id="modal-area-tv" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
          <button class="uk-modal-close-default" type="button" uk-close></button>
          <img src="../assets/roomi_store/foto_store/area display tv.jpg" alt="../Asset 2@2x.png" width="100%" height="100%" uk-img>
      </div>
  </div>
  <div id="modal-area-cctv" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
          <button class="uk-modal-close-default" type="button" uk-close></button>
          <img src="../assets/roomi_store/foto_store/area cctv dan ott box.jpg" alt="../Asset 2@2x.png" width="100%" height="100%" uk-img>
      </div>
  </div>
  <div id="modal-testing" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
          <button class="uk-modal-close-default" type="button" uk-close></button>
          <img src="../assets/roomi_store/foto_store/testing spk.jpg" alt="../Asset 2@2x.png" width="100%" height="100%" uk-img>
      </div>
  </div>
		 -->

     <br>
		<div class="uk-section uk-padding-remove">

			<hr>
		</div>

		<Footer />
	</div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Footer from '@/components/Footer.vue'
import MainBannerProduct from '@/components/MainBannerProduct.vue'
import DownloadBanner from '@/components/DownloadBanner.vue'
import VueCompareImage from 'vue-compare-image'
import axios from "axios";

export default {
	name: 'spye',
    assetsSubDirectory: "@/assets",
	components: {
		NavigationBar,
		Breadcrumb,
		MainBannerProduct,
		DownloadBanner,
		VueCompareImage,
		Footer
	},
	data () {
		return {
      sliders: [],
			Breadcrumb: {
			productName: 'spye'
			},
			banner: {
				productName: 'spye',
				tagline: 'keeping your family safe',
				features: ['security', 'remote monitor', 'app control', '2 way mic'],
				link: 'https://youtu.be/X-p20C2mugs',
				img: require('../assets/spye-banner-1.png'),
				posTop: '-5px',
				posBottom: '-135px',
				imageScale: 'scale(1.25)',
				price: '',
			},
      store_pik: [
        {
        	backgroundImage: require('../assets/images/home/cctv.jpeg'),
          detailLink: '/store_roomi',
          buyLink: '/store_roomi',
        },
      ],
      loadingSlider: false,
      loadingSlideshow: false,
		}
	},
    mounted() {},
    computed: {
    slidersCount: function () {
      return Number(this.sliders.length);
    },
  },
	mounted () {
		this.getBannerSlider();
        this.getSlideShow();
	},
	methods: {
		getBannerSlider() {
      this.loadingSlider = true;
      const params = {
        type: "slider",
      };
      const paramsString = new URLSearchParams(params).toString();
      axios
        .get(`${process.env.VUE_APP_API_ROOMI_URL}banner?${paramsString}`)
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              this.loadingSlider = false;
              const temp = [];
              for (const item of data.data) {
                temp.push({
                  link: item.link,
                  backgroundImage: item.image,
                  name: item.name,
                });
              }
              this.sliders = temp;
            } else {
              UIkit.notification({
                status: "danger",
                message: "Something wen't wrong!",
              });
            }
          } else {
            UIkit.notification({
              status: "danger",
              message: "Something wen't wrong!",
            });
          }
        })
        .catch((err) => {
          UIkit.notification({
            status: "danger",
            message: "Something wen't wrong!",
          });
        });
    },
    getSlideShow() {
      this.loadingSlideshow = true;
      const params = {
        type: "slideshow",
      };
      const paramsString = new URLSearchParams(params).toString();
      axios
        .get(`${process.env.VUE_APP_API_ROOMI_URL}banner?${paramsString}`)
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              this.loadingSlideshow = false;
              const temp = [];
              for (const item of data.data) {
                temp.push({
                  link: item.link,
                  backgroundImage: item.image,
                  name: item.name,
                });
              }
              this.slideshows = temp;
            } else {
              UIkit.notification({
                status: "danger",
                message: "Something wen't wrong!",
              });
            }
          } else {
            UIkit.notification({
              status: "danger",
              message: "Something wen't wrong!",
            });
          }
        })
        .catch((err) => {
          UIkit.notification({
            status: "danger",
            message: "Something wen't wrong!",
          });
        });
    },
	}
}
</script>

<style scoped>
#section-one {
  padding-top: 0;
  padding-bottom: 0;
}

#section-one .slideshow-item {
  min-height: 100%;
  width: 100%;
  background-size: 100%;
  object-fit: contain;
  background-position: top center;
  background-repeat: no-repeat;
}
@media screen and (max-width: 1024px) {
  #section-one .uk-slideshow-items {
    min-height: 350px !important;
  }
}
@media screen and (max-width: 769px) {
  #section-one .uk-slideshow-items {
    min-height: 220px !important;
  }
}

@media screen and (max-width: 425px) {
  #section-one .uk-slideshow-items {
    min-height: 145px !important;
  }
}

@media screen and (max-width: 375px) {
  #section-one .uk-slideshow-items {
    min-height: 120px !important;
  }
}

@media screen and (max-width: 639px) {
  #section-one .slideshow-item {
    height: auto;
    background-size: 100%;
    background-position-x: left;
    background-position-y: 0;
  }

  #section-one .uk-slideshow-items {
    min-height: 166px !important;
  }

  .slideshow-one-text {
    top: 30%;
    left: 45%;
    margin-top: 5%;
    margin-left: 5%;
    max-width: 90%;
  }

  .slideshow-one-text h4 {
    font-size: 14px;
    line-height: 14px;
    text-align: left;
  }

  .slideshow-one-text h1 {
    font-size: 24px;
    line-height: 24px;
    text-align: left;
  }

  .slideshow-item a {
    background-color: rgba(45, 61, 120, 0.9);
    line-height: 25px;
    height: 25px;
    width: 90px;
    font-size: 10px;
    padding-left: 0;
    padding-right: 0;
    border-left-width: 0px;
    float: left;
  }
}

@media screen and (max-width: 375px) {
  #section-one .uk-slideshow-items {
    min-height: 120px !important;
  }
}

@media screen and (min-width: 640px) and (max-width: 960px) {
  .slideshow-one-text h1 {
    font-size: 28px;
    line-height: normal;
  }

  .slideshow-one-text h4 {
    font-size: 12px;
    line-height: normal;
  }

  .slideshow-item a {
    width: 150px;
    font-size: 12px;
  }
}

@media screen and (min-width: 1870px) {
  .slideshow-item a {
    width: 200px;
  }
}

.image-container img {
  border-radius: 20px; /* Adjust the value as needed */
}

.uk-slider-items img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Ensure the image covers the entire container */
}


@media screen and (max-width: 640px) {
  #section-two .uk-grid-small {
    margin-left: -180px !important;
    width: 700px !important;
  }
}

@media screen and (min-width: 640px) {
  .left-sample img {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }

  .right-sample img {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }
}

@media screen and (max-width: 640px) {
  .left-sample img {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }

  .right-sample img {
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }
}

</style>